import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'out-cookie-consent',
  imports: [CommonModule],
  templateUrl: './cookie-consent.component.html',
  styleUrl: './cookie-consent.component.scss',
})
export class CookieConsentComponent implements OnInit {
  showConsent = true;

  ngOnInit() {
    this.showConsent = localStorage.getItem('cookieConsent') === null;
  }

  acceptCookies() {
    localStorage.setItem('cookieConsent', 'accepted');
    this.showConsent = false;
  }

  declineCookies() {
    localStorage.setItem('cookieConsent', 'declined');
    this.showConsent = false;
  }
}
